import {
  MEMBERS_APP_STORE_URL,
  MEMBERS_PLAY_STORE_URL,
} from '@constants/appStores'
import { useNotificationDevices } from '@services/api/graphql/queries/notificationDevices'
import { useTranslation } from 'react-i18next'
import { Anchor, Text, XStack, YStack } from 'tamagui'

const STORES = [
  { id: 'app-store', url: MEMBERS_APP_STORE_URL },
  { id: 'google-play', url: MEMBERS_PLAY_STORE_URL },
] as const

export function PushDeviceStatus() {
  const { t } = useTranslation('Push')
  const { hasActiveDevice } = useNotificationDevices()

  if (hasActiveDevice !== false) return null

  return (
    <YStack
      testID="push-install-app"
      gap="$size.spacing-xxs"
      padding="$size.spacing-xs"
      br="$border-radius-sm"
      backgroundColor="$bg-surface-sunken"
    >
      <Text
        ff="$mulishRegular"
        fontSize="$font-size-xxxs"
        color="$text-secondary"
      >
        {t('preferences.device.installApp')}
      </Text>
      <XStack gap="$size.spacing-xs" flexWrap="wrap">
        {STORES.map(({ id, url }) => (
          <Anchor
            key={id}
            testID={`push-store-${id}`}
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            accessibilityRole="link"
            accessibilityLabel={t(`preferences.device.stores.${id}.label`)}
            ff="$mulishBold"
            fontSize="$font-size-xxxs"
            color="$accent"
            textDecorationLine="underline"
          >
            {t(`preferences.device.stores.${id}.name`)}
          </Anchor>
        ))}
      </XStack>
    </YStack>
  )
}
